<template>
  <v-btn-toggle
    :style="{display: 'flex', flexDirection: 'column'}"
  >
    <v-btn text @click="setElementToImage({rowIndex, elementIndex })">New image element</v-btn>
    <v-btn
      text
      @click="setElementToText({rowIndex: rowIndex, elementIndex: elementIndex })"
    >
      New text element
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'RowElementEmpty',
  props: {
    elementData: {
      type: Object,
    },

    elementIndex: {
      type: Number,
    },

    rowIndex: {
      type: Number,
    },
  },

  data: () => ({
  }),

  methods: {
    ...mapActions({
      setElementToText: 'microsite/setElementToText',
      setElementToImage: 'microsite/setElementToImage',
    }),
  },
};
</script>

<style scoped>
</style>
